"use client";
import {
  usePopoverHeading
} from "./4FY2MBIB.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./HKOOKEDE.js";

// src/hovercard/hovercard-heading.tsx
var TagName = "h1";
var useHovercardHeading = createHook(
  function useHovercardHeading2(props) {
    props = usePopoverHeading(props);
    return props;
  }
);
var HovercardHeading = forwardRef(function HovercardHeading2(props) {
  const htmlProps = useHovercardHeading(props);
  return createElement(TagName, htmlProps);
});

export {
  useHovercardHeading,
  HovercardHeading
};
